import { useState } from 'react';
import { Badge, Popover, List, Avatar, Button, Typography } from 'antd';
import { BellOutlined, GiftOutlined, MessageOutlined, SettingOutlined, CheckCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const notifications = [
  { id: 1, icon: <GiftOutlined />, color: '#52c41a', bg: '#f6ffed', text: "It's Cristina danny's birthday today.", time: '2 min ago' },
  { id: 2, icon: <MessageOutlined />, color: '#1677ff', bg: '#e6f4ff', text: 'Aida Burg commented your post.', time: '5 August' },
  { id: 3, icon: <SettingOutlined />, color: '#ff4d4f', bg: '#fff2f0', text: 'Your Profile is Complete 60%', time: '7 hours ago' },
  { id: 4, icon: null, color: '#1677ff', bg: '#e6f4ff', text: 'Cristina Danny invited to join Meeting.', time: 'Daily scrum' }
];

export default function Notification() {
  const [read, setRead] = useState(2);
  const [open, setOpen] = useState(false);

  const content = (
    <div style={{ width: 320 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <Text strong>Notification</Text>
        {read > 0 && (
          <Button type="text" size="small" icon={<CheckCircleOutlined style={{ color: '#52c41a' }} />} onClick={() => setRead(0)} />
        )}
      </div>
      <List
        dataSource={notifications}
        renderItem={(item) => (
          <List.Item style={{ padding: '8px 0', cursor: 'pointer' }}>
            <List.Item.Meta
              avatar={
                <Avatar style={{ backgroundColor: item.bg, color: item.color }}>
                  {item.icon || 'C'}
                </Avatar>
              }
              title={<Text style={{ fontSize: 13 }}>{item.text}</Text>}
              description={<Text type="secondary" style={{ fontSize: 12 }}>{item.time}</Text>}
            />
          </List.Item>
        )}
        footer={
          <div style={{ textAlign: 'center' }}>
            <Button type="link" size="small">View All</Button>
          </div>
        }
      />
    </div>
  );

  return (
    <Popover content={content} trigger="click" open={open} onOpenChange={setOpen} placement="bottomRight">
      <Badge count={read} size="small">
        <Button shape='circle' type="text" icon={<BellOutlined style={{ fontSize: 18 }} />} />
      </Badge>
    </Popover>
  );
}
